<template>
	<div>
    <v-card>
      <v-card-title>
        {{ $store.state.user.expediente.nombre }}
      <v-spacer />
        <v-text-field 
          v-model="search"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer />
        <v-btn  
          rounded dark 
          class="ml-2" 
          color="info"
          :to="{name: 'lote_carga'}">
          <v-icon color="lighten-1">mdi-plus</v-icon>
          Cargar nuevo lote
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="array_docs"
        :options.sync="pagination"
        loading-text="Cargando..."
        no-data-text="No hay registros a mostrar"      
        :server-items-length="total"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 20, 50, 100],
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          itemsPerPageText:'Registros por página'
        }"
        class="elevation-1"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn 
             class="ma-1"
            outlined
            x-small
            fab
           color="grey darken-1"
            title="Documentos"
            @click="detalleLote(item)">
            <v-icon>mdi-eye-check-outline</v-icon>
          </v-btn>

          <v-btn 
              class="ma-1"
      outlined
      x-small
       fab
      color="grey darken-1"
            title="Descargar"
            :loading="item.clave_firma"
            @click="descargarLote(item)">
            <v-icon>mdi-download</v-icon>
          </v-btn>

          <v-btn 
              class="ma-2"
      outlined
      x-small
       fab
      color="grey darken-1"
            title="Eliminar"
            :loading="item.clave_firma"
            :disabled="item.usuario_carga != $store.state.user.email"
            @click="deleteDocument(item)">
            <v-icon>mdi-close-thick</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.firma="{ item }">
          <span v-if="item.firma == 'N'">No</span>
          <v-chip 
          v-else
            x-small 
            label 
            :color="item.firma == 'N' ? 'black' : 'success'" 
            text-color="white">
            Si
          </v-chip>
        </template>

        <template v-slot:item.estado="{ item }">
          <v-chip 
            x-small label class="ma-2"
            :color="getColor(item.estado)"
            text-color="white">
            {{ item.estado }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>

import axios from "axios";
export default {
	props: ['opt',],
  data: function() {
    return {
      search: '',
      carpeta_id: "",
      array_docs: [],
      headers: [
        // { text: 'ID', sortable: true, value: 'id',},
        { text: 'Nombre', sortable: true, value: 'nombre',},
        { text: 'Archivo', sortable: true, value: 'nombre_archivo_carga',},
        { text: 'Total archivos', sortable: true, value: 'total_archivos',},
        { text: 'Flujo',  sortable: false,value: 'nombre_flujo'},
        { text: 'Fecha carga', sortable: true, value: 'fecha_carga_formateada',},
        { text: 'Cargado por', sortable: false, value: 'usuario_carga'},
        { text: '¿Firma?', sortable: false, value: 'firma'},
        { text: 'Estado', sortable: true, value: 'estado',},
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      options: {},
      categories: [],
      total: 0,
      loading: false,
      pagination: {},
    };
  },
  computed: {
    
  },
  watch: {
    pagination: {
      handler () {
        this.getCategoriesByPagination();
      },
      deep: true,
    },
    search: {
      handler () {
        this.getCategoriesByPagination();
      },
      deep: true,
    },
  },
  created () {
    
  },
  mounted() {
  	//console.log(this.opt);
  },
  methods: {
    getCategoriesByPagination() {
      this.loading = true;

      // get by search keyword
      if (this.search) {
          let getdoc = axios.get('Lotes/listar_paginacion?u=l&query='+this.search+'&page='+this.pagination.page+'&per_page='+this.pagination.itemsPerPage, { 'headers': this.$store.state.user.headers })
          return getdoc.then(res => {
            //console.log(res);
            this.array_docs = res.data.items;
            this.total = res.data.total;
          })
          .catch(err => console.log(err.response.data))
          .finally(() => this.loading = false);
      }
      // get by sort option
      if (!this.search && this.pagination.sortBy) {
          const direction = this.pagination.sortDesc[0] ? 'desc' : 'asc';
          let getdoc = axios.get('Lotes/listar_paginacion?u=l&direction='+direction+'&sortBy='+this.pagination.sortBy+'&page='+this.pagination.page+'&per_page='+this.pagination.itemsPerPage, { 'headers': this.$store.state.user.headers })
          return getdoc.then(res => {
            //console.log(res);
            this.loading = false;
            this.array_docs = res.data.items;
            this.total = res.data.total;
          })
          .catch(err => console.log(err.response.data))
          .finally(() => this.loading = false);
      } 
      if(!this.search && !this.pagination.sortBy) {
          let getdoc = axios.get('Lotes/listar_paginacion?u=u&page='+this.pagination.page+'&per_page='+this.pagination.itemsPerPage, { 'headers': this.$store.state.user.headers })
          return getdoc.then(res => {
            //console.log(res);
            this.array_docs = res.data.items;
            this.total = res.data.total;
          })
          .catch(err => console.log(err.response.data))
          .finally(() => this.loading = false);
      }
    },
    deleteDocument(item) {
      console.log("Eliminar el Lote: " + item.id);
      let r = confirm("¿Seguro de eliminar el lote: " + item.nombre + "?");
      if (r == true) 
      {
        item.clave_firma = true;
        let item_array = this.array_docs.findIndex(v => v.id == item.id);
        let getdoc = axios.delete('Lotes/Eliminar?id='+ item.id, { 'headers': this.$store.state.user.headers })
        return getdoc.then((callback) => {
          console.log("callback eliminar: " + callback.status);
          item.clave_firma = false;
          if(callback.status == 200) {
            this.array_docs.splice(item_array, 1);
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Documento eliminado con éxito.' });
          }else {
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en el proceso.' });
          }
        }).catch((error) => {
          item.clave_firma = false;
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: error.response.data });
          console.log(error.response.data);
        });
      }
    },
    detalleLote(item){
      //console.log(item);
      this.$store.state.user.lote_seleccionado = item;
      this.$router.push({name: 'lote_documentos', params: {'id': item.id}});
    },
    descargarLote(item) 
    {
      let getdoc = axios({
        method: 'GET',
        url: 'Lotes/descargar?id='+ item.id,
        responseType: 'blob',
        headers: this.$store.state.user.headers
      })
      return getdoc.then((callback) => 
      {
        if(callback.status == 200) 
        {
          let blob = new Blob([callback.data], {
            type: 'application/octet-stream'
          }) 
          const element = document.createElement("a");
          element.setAttribute("href", window.URL.createObjectURL(blob));
          element.setAttribute("download", "infile-sign-lote-"+item.nombre_archivo_carga);
          element.style.display = "none";
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        }else {
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en el proceso.' });
        }
      }).catch((error) => {
        console.log(error);
        console.log(error.response);
        this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en el proceso de descarga' });
      });
    },
    getColor(status){
      let s;
      switch(status){
        case 'CANCELADO': s = "error"; break;
        case 'FIRMANDO': case 'FIRMADO': s = "info"; break;
        case 'ACTIVO': s = "success"; break;
        case 'CARGANDO': s = "black"; break;
        default: s = "primary"
      }
      return s;
    }
  }
};
</script>